export default __webpack_public_path__ + "static/media/NB-H3801-SeeAll-accessories.378092d3.jpg";